<template >
  <div
    class="form-group formways-component formways-checkbox"
    :class="ctx.customClass"
    v-if="!ctx.hidden"
  >
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        :id="ctx.key"
        v-model="value"
        :disabled="ctx.disabled"
        :required="ctx.validate.required"
      />
      <label class="form-check-label" :for="ctx.key">
        {{ ctx.label }}
        <span v-if="ctx.validate.required" class="text-danger">*</span>
        <i
          v-if="ctx.tooltip"
          class="fa fa-question-circle"
          aria-hidden="true"
          data-toggle="tooltip"
          data-placement="right"
          :title="ctx.tooltip"
        ></i>
      </label>
      <small :id="ctx.key + 'Help'" class="form-text text-muted">
        {{ ctx.description }}
      </small>
    </div>
  </div>
</template>

<script>
import FieldMixin from '../../mixins/FieldMixin';
import defaultSchema from './defaultSchema';

export default {
  name: 'checkbox',
  mixins: [FieldMixin],
  beforeCreate() {
    // Default schema
    this.defaultSchema = defaultSchema;
  },
  created() {
    this.initFieldValue();
  },
  methods: {
    reset() {
      this.value = false;
      this.initFieldValue();
    }
  }
};
</script>
